import React from 'react';
import {
    FullScreen,
    WhiteBox,
    AllCheckBlock,
    CheckBoxLabel,
    SelectCheckBlock,
    SmallCheckBoxLabel,
    TermsAndPositionLink,
    SignupCompleteBtn,
    DisableSignupCompleteBtn
} from './style';
import CheckBox from 'components/presenters/button/CheckBox';

const TermsAndConditionModal = ({
    onAllChecked, 
    isSelectAll, 
    onSingleCheck, 
    checkItemsState, 
    checkItems,
    termsAndConditionValid,
    onSignupComplete,
    onClickOutSide,
    modalRef
}) => {
    
    return(
        <FullScreen onClick={onClickOutSide}>
            <WhiteBox  ref={modalRef}>
                <AllCheckBlock>
                    <CheckBoxLabel>
                        <CheckBox checked={isSelectAll} onChange={onAllChecked}/>
                        <span>약관에 모두 동의</span>
                    </CheckBoxLabel>
                </AllCheckBlock>
                <SelectCheckBlock>
                    {checkItemsState.map((item, index) => 
                        <SmallCheckBoxLabel key={index}>
                            <CheckBox checked={checkItems.includes(item['id'])} onChange={(e) => onSingleCheck(e, item['id'])}/>
                            <span>{item['description']}</span>
                            {item['openModal'] ? <TermsAndPositionLink onClick={item['openModal']}>보기</TermsAndPositionLink> : null}
                            
                        </SmallCheckBoxLabel>
                    )}
                </SelectCheckBlock>
                {termsAndConditionValid ? (
                    <SignupCompleteBtn onClick={termsAndConditionValid ? onSignupComplete : null}>
                        회원가입 완료
                    </SignupCompleteBtn>
                ) : (
                    <DisableSignupCompleteBtn>
                        회원가입 완료
                    </DisableSignupCompleteBtn>
                )}
            </WhiteBox>
        </FullScreen>
    );
}

export default TermsAndConditionModal;